import React from 'react'

import { Form } from '_zari/core'

const HeadFilter = ({ type, name, tableId, onChange }) => {
  const [filterValue, setFilterValue] = React.useState(null)

  const delayRef = React.useRef()

  const componenteId = React.useMemo(() => {
    return `${tableId}-filter-${name}`
  }, [tableId, name])

  React.useEffect(() => {
    if (filterValue !== null) {
      delayRef.current = setTimeout(() => onChange(name, filterValue), 500)
      return () => clearTimeout(delayRef.current)
    }
  }, [filterValue, onChange, name])

  return (
    <>
      {type === 'text' ? (
        <Form.InputText
          id={componenteId}
          name={componenteId}
          onChange={e => setFilterValue(e.target.value)}
          value={filterValue || ''}
        />
      ) : null}
    </>
  )
}

export default React.memo(HeadFilter)
